import {useEffect, useLayoutEffect, useRef, useState} from "react";
import SimpleCardBox from "./SimpleCardBox";
import "./CollapsibleItem.css";

const CollapsibleItem = ({toggleBreaker, doEverOpen = true, title, titleItems, extraOnToggle = () => {}, startCollapsed = true, children, radioStyler = false}) => {
    const [isCollapsed, setIsCollapsed] = useState(startCollapsed);
    const contentRef = useRef(null);

    const toggleCollapse = () => {
        extraOnToggle();

        setIsCollapsed(!isCollapsed);
    };

    useLayoutEffect(() => {
        toggleSelf();

        onToggle();
    }, [isCollapsed, children, toggleBreaker]);

    useEffect(() => {
        setIsCollapsed(startCollapsed);
    }, [startCollapsed]);

    const [everOpen, setEverOpen] = useState(false);
    const [everOpenTimeout, setEverOpenTimeout] = useState(null);

    function toggleSelf() {
        if (contentRef.current) {
            if (isCollapsed) {
                // Collapse animation - set max-height to 0
                contentRef.current.style.maxHeight = '0px';
                contentRef.current.classList.add('collapsible-payload-collapsed');

                // onToggle(-contentRef.current.scrollHeight);
            } else {
                // Expand animation - set max-height to scroll height
                contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
                contentRef.current.classList.remove('collapsible-payload-collapsed');

                // onToggle(contentRef.current.scrollHeight);
            }
        }

        if (everOpenTimeout)
            clearTimeout(everOpenTimeout);
        setEverOpenTimeout(null);

        if (!isCollapsed)
            setEverOpen(true);
        else {
            setEverOpenTimeout(setTimeout(() => {
                setEverOpen(false)
            }, 5000));
        }
    }

    function onToggle() {
        const current = contentRef?.current;
        const children = [...(current?.children ?? [])];
        const offset = children.reduce((out, curr) => out + Number(curr.lastChild?.style?.maxHeight.match(/\d+/) ?? 0), 0);
        // console.log("Group Height", client.abbreviation, current?.scrollHeight ?? null, offset);

        if (contentRef.current) {
            if (isCollapsed) {
                // Collapse animation - set max-height to 0
                contentRef.current.style.maxHeight = '0px';
                contentRef.current.classList.add('collapsible-payload-collapsed');
            } else {
                // Expand animation - set max-height to scroll height
                contentRef.current.style.maxHeight = (contentRef.current.scrollHeight + offset) + 'px';
                contentRef.current.classList.remove('collapsible-payload-collapsed');
            }
        }
    }

    return (
        <SimpleCardBox defaultPadding={false} defaultMargin={false} extraClass={`collapsible-item-box ${radioStyler ? "edit-card-edit-entry" : ""}`}>
            <div onClick={toggleCollapse} className={"qc-header-row simple-flex-row"} style={{alignItems: "center"}}>
                {title? <h4>
                    {/*<span className="qc-toggle-button">{isCollapsed ? '▶' : '▼'} </span>*/}
                    {title}
                </h4> : null}
                {titleItems}
            </div>
            <div className={`collapsible-payload ${startCollapsed ? "collapsible-payload-collapsed" : ""}`} ref={contentRef}>
                {(everOpen && doEverOpen) || !isCollapsed ? children : null}
            </div>
        </SimpleCardBox>
    );
}

export default CollapsibleItem;